import swal from "sweetalert2";

var topnavbar;

import AdminApi from '../../services/api'
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import COMPANIES from "../../services/ListCompany";
import Loc from "../../services/localization";
import TAB_CONFIG from "../../services/tabConfig";
import { getBaseApi } from "../../services/BaseApi";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    computed: {
        routeName() {
            const {name} = this.$route
            return this.capitalizeFirstLetter(name)
        },
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        }
    },

    data() {
        return {
            locale: LocService,
            lastScannedBarCode: '',
            myRole: '',
            interval: null,
            barcode: '',
            isLoadingTrainings: false,
            payment: '',
            paymentStyle : '',
            activeNotifications: false,
            changePasswordModalVisible: false,
            restOfTraining: 0,
            isOpen: false,
            companyName: CONFIG_COMPANY.NAME,
            currentBalance: 0,
            showRestTrainings: true,
            showPackageMembership: CONFIG_COMPANY.SHOW_PACKAGE_MEMBERSHIP,
            qrScannerFocusEnabled: CONFIG_COMPANY.USE_QR_SCANNER_FOCUS != null ? CONFIG_COMPANY.USE_QR_SCANNER_FOCUS : false,
            model: {
                id: 0,
                email: '',
                name: '',
                phone: '',
                surname: '',
                username: '',
                role: null
            },
            expireDate: null,
            timeout: null,
            tabs: [],
            rightTabs: CONFIG_COMPANY.RIGHT_TABS,
            isSidebarCollapsed: false,
            showMembershipCard: true,
            themeMode: 'dark',
            logoImage: null,
            desktopNavMode: 'topbar',
            topbarActionsOpen: false,
            topbarSubmenuItem: null,
            topbarSubmenuStyle: null,
            topbarSubmenuHover: false,
            topbarSubmenuCloseTimer: null,
            enableChat: CONFIG_COMPANY.ENABLE_CHAT != null ? CONFIG_COMPANY.ENABLE_CHAT : false,
            chatUnreadCount: 0,
            chatUnreadTimeout: null,
        }
    },

    beforeMount() {
        topnavbar = this;
        this.myRole = session.getRole();
        this.showMembershipCard = !(session.getConfig().hideMembershipCard === true);
        this.showRestTrainings = session.getConfig().showRestTrainings == null ? true : session.getConfig().showRestTrainings
        this.shouldUseQrScannerAsEntrance = session.getConfig().shouldUseQrScannerAsEntrance == null ? false : session.getConfig().shouldUseQrScannerAsEntrance
        if(CONFIG_COMPANY.SPECIFIC_ROLES != null){
            if(CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()] != null){
                if(CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()].RIGHT_TABS != null){
                    this.rightTabs = CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()].RIGHT_TABS;
                }
            }
        }
        this.loadUser()
        this.loadBalance();
        this.generateTabs();
            this.logoImage = getBaseApi() + 'company-image/' + this.companyName;
        this.isSidebarCollapsed = localStorage.getItem('SIDEBAR_COLLAPSED') === 'true';
        this.applySidebarMode();
        const storedDesktopNavMode = localStorage.getItem('DESKTOP_NAV_MODE');
        this.desktopNavMode = storedDesktopNavMode === 'sidebar' ? 'sidebar' : 'topbar';
        this.applyDesktopNavMode();
        const storedThemeMode = localStorage.getItem('THEME_MODE');
        this.themeMode = storedThemeMode === 'light' ? 'light' : 'dark';
        this.applyThemeMode();
        this.startChatUnreadPolling();
    },

    created() {
        this.$topnavbar.$on('newTrainings', () => {
            this.loadUser()
        });

        this.$topnavbar.$on('load', () => {
            swal({
                title: "",
                text: "",
                type: "",
                // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
                html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_reserving_training') + "</div>",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: 'swal-custom'
            }, function (selection) {

            });
        });

        this.$topnavbar.$on('cancelTrainings', () => {
            swal({
                title: "",
                text: "",
                type: "",
                // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
                html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_canceling_training') + "</div>",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: 'swal-custom'
            }, function (selection) {

            });
        });

        this._reserveQrTrainingListener = (username) => {
            if (username == null || ('' + username).trim().length === 0) return;
            this.reserveQrTraining(('' + username).trim());
        };
        this.$topnavbar.$on('reserveQrTraining', this._reserveQrTrainingListener);
        this._refreshChatUnreadCountListener = () => {
            this.refreshChatUnreadCount();
        };
        this.$topnavbar.$on('refreshChatUnreadCount', this._refreshChatUnreadCountListener);
        this._chatUnreadVisibilityListener = () => {
            this.handleChatUnreadVisibilityChange();
        };
        document.addEventListener('visibilitychange', this._chatUnreadVisibilityListener);
        document.addEventListener('click', this.handleDocumentClick);
        if(session.getRole() === 'ROLE_USER') return;
        let useQrCode = session.getConfig().useQrCode != null ? session.getConfig().useQrCode : false;
        let useFocusForScannerTimedSlot = session.getConfig().useFocusForScannerTimedSlot != null ? session.getConfig().useFocusForScannerTimedSlot : false;
        if(useQrCode && !useFocusForScannerTimedSlot){
            let _self = this;
            document.addEventListener('keydown', _self.qrScanListener)
        }
        //TODO resiti prevode i cuvanje u shared preference
        this.listenQrApproved();
        this.listenRemoteOpenDoor();
    },

    destroyed() {
        document.removeEventListener('keydown', this.qrScanListener);
        this.$topnavbar.$off('reserveQrTraining', this._reserveQrTrainingListener);
        this.$topnavbar.$off('refreshChatUnreadCount', this._refreshChatUnreadCountListener);
        document.removeEventListener('visibilitychange', this._chatUnreadVisibilityListener);
        document.removeEventListener('click', this.handleDocumentClick);
        if (this.topbarSubmenuCloseTimer) {
            clearTimeout(this.topbarSubmenuCloseTimer);
        }
        this.stopChatUnreadPolling();
        document.body.classList.remove('sidebar-collapsed');
        document.body.classList.remove('desktop-nav-topbar');
    },

    methods: {
        reserveQrTraining: reserveQrTraining,
        userNotExist: userNotExist,
        qrScanListener: qrScanListener,
        generateTabs: generateTabs,
        resetRemoteAfterOpen: resetRemoteAfterOpen,
        onClickTab: onClickTab,
        onClickTabFromParent: onClickTabFromParent,
        loadBalance: loadBalance,
        listenQrApproved: listenQrApproved,
        openDoorSonOff: openDoorSonOff,
        listenRemoteOpenDoor: listenRemoteOpenDoor,
        openDoor: openDoor,
        setTimer: setTimer,
        showSubMenu(id) {
            const item = this.tabs.find(tab => tab.id === id);
            if (item) item.isOpen = true;
        },
        hideSubMenu(id) {
            const item = this.tabs.find(tab => tab.id === id);
            if (item) item.isOpen = false;
        },
        toggleMenu() {
            this.isOpen = !this.isOpen;
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown() {
            this.activeNotifications = false;
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar() {
            this.$sidebar.displaySidebar(false);
        },
        signOut() {
            this.$router.push('/login');
            this.$sessionService.destroyUser();
        },
        home() {
            this.toggleMenu()
            var home = CONFIG_COMPANY.HOME
            this.$router.push(home);
        },
        notifications() {
            this.toggleMenu()
            this.$router.push('/notification');
        },
        trainings() {
            this.toggleMenu()
            this.$router.push('/trainings');
        },
        users() {
            this.toggleMenu()
            this.$router.push('/users');
        },
        profile() {
            this.toggleMenu()
            this.$router.push('/profile');
        },
        profit() {
            this.toggleMenu()
            this.$router.push('/profit');
        },
        invoices(){
            this.toggleMenu()
            this.$router.push('/invoices');
        },
        entrance(){
            this.toggleMenu()
            this.$router.push('/entrance');
        },
        subscriptions(){
            this.toggleMenu()
            this.$router.push('/subscription-report');
        },
        orders(){
            this.toggleMenu()
            this.$router.push('/orders');
        },
        personal(){
            this.toggleMenu()
            this.$router.push('/personal');
        },
        docs() {
            this.toggleMenu()
            this.$router.push('/admin-instruction');
        },
        adminChat() {
            this.toggleMenu()
            this.$router.push('/admin-chat');
            this.refreshChatUnreadCount();
        },
        isChatEnabled() {
            return CONFIG_COMPANY.ENABLE_CHAT === true && this.myRole !== 'ROLE_USER';
        },
        shouldUseChatUnreadCount() {
            return this.isChatEnabled() && ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_TRAINER'].includes(this.myRole) && localStorage.getItem('ACCESS_TOKEN') != null;
        },
        startChatUnreadPolling() {
            this.stopChatUnreadPolling();
            if (!this.shouldUseChatUnreadCount()) {
                this.chatUnreadCount = 0;
                return;
            }
            this.refreshChatUnreadCount();
            this.scheduleChatUnreadPolling();
        },
        scheduleChatUnreadPolling() {
            if (!this.shouldUseChatUnreadCount()) return;
            this.chatUnreadTimeout = setTimeout(() => {
                this.refreshChatUnreadCount();
                this.scheduleChatUnreadPolling();
            }, 120000);
        },
        handleChatUnreadVisibilityChange() {
            if (document.hidden) {
                this.stopChatUnreadPolling();
                return;
            }
            this.startChatUnreadPolling();
        },
        stopChatUnreadPolling() {
            if (this.chatUnreadTimeout != null) {
                clearTimeout(this.chatUnreadTimeout);
                this.chatUnreadTimeout = null;
            }
        },
        refreshChatUnreadCount() {
            if (!this.shouldUseChatUnreadCount()) {
                this.chatUnreadCount = 0;
                return;
            }
            AdminApiService.getChatUnreadCount()
                .then((response) => {
                    this.chatUnreadCount = response.data != null && response.data.count != null ? response.data.count : 0;
                })
                .catch(() => {
                    this.chatUnreadCount = 0;
                });
        },
        getChatUnreadCountLabel() {
            return this.chatUnreadCount > 99 ? '99+' : this.chatUnreadCount;
        },
        articleReport() {
            this.toggleMenu()
            this.$router.push('/articles-report');
        },
        wod(){
            this.toggleMenu()
            this.$router.push('/wod');
        },
        barSaldoDebtors(){
            this.toggleMenu()
            this.$router.push('/bar-saldo-debtors');
        },
        myPayments(){
            this.toggleMenu()
            this.$router.push('/my-payments?id=' + this.model.id + '&name=' + this.model.name + ' ' + this.model.surname + '&restOfTrainings=' + this.model.restOfTraining + '&expireDate=' + this.model.expireDate)
        },
        terms() {
            this.toggleMenu()
            this.$router.push('/pre-terms');
        },
        trainingReport() {
            this.toggleMenu()
            this.$router.push('/training-report');
        },
        paymentReport(){
            this.toggleMenu()
            this.$router.push('/payment-report');
        },
        saradnici(){
            this.toggleMenu()
            this.$router.push('/company-payment');
        },
        userCredits(){
            this.toggleMenu()
            this.$router.push('/user-credits');
        },
        companyPartner(){
            this.toggleMenu()
            this.$router.push('/company-partner');
        },
        shop(){
            this.toggleMenu()
            this.$router.push('/shop');
        },
        barPos(){
            this.toggleMenu()
            this.$router.push('/bar-pos');
        },
        ordersReservation(){
            this.toggleMenu()
            this.$router.push('/orders-reservation');
        },
        trainingTypes(){
            this.toggleMenu()
            this.$router.push('/training-types');
        },
        warehouses(){
            this.toggleMenu()
            this.$router.push('/warehouses');
        },
        inventory(){
            this.toggleMenu()
            this.$router.push('/inventory-history');
        },
        companies(){
            this.toggleMenu()
            this.$router.push('/companies');
        },
        employedUsers(){
            this.toggleMenu()
            this.$router.push('/employed-users');
        },
        articles(){
            this.toggleMenu()
            this.$router.push('/articles');
        },
        campaign(){
            this.toggleMenu()
            this.$router.push('/campaign-list');
        },
        campaignCompany(){
            this.toggleMenu()
            this.$router.push('/campaign-company');
        },
        userReport(){
            this.toggleMenu()
            this.$router.push('/user-report');
        },
        cSchedule(){
            this.toggleMenu()
            this.$router.push('/c-schedule');
        },
        trainerReport(){
            this.toggleMenu()
            this.$router.push('/trainer-report');
        },
        membershipPackages(){
            this.toggleMenu()
            this.$router.push('/membership-packages');
        },
        timedSlots(){
            this.toggleMenu()
            this.$router.push('/timed-slots');
        },
        toggleSidebarMode() {
            this.isSidebarCollapsed = !this.isSidebarCollapsed;
            localStorage.setItem('SIDEBAR_COLLAPSED', this.isSidebarCollapsed ? 'true' : 'false');
            this.applySidebarMode();
        },
        setDesktopNavMode(mode) {
            this.desktopNavMode = mode === 'topbar' ? 'topbar' : 'sidebar';
            localStorage.setItem('DESKTOP_NAV_MODE', this.desktopNavMode);
            this.applyDesktopNavMode();
            this.$topnavbar.$emit('desktopNavModeChanged', this.desktopNavMode);
            this.topbarActionsOpen = false;
            this.closeTopbarSubmenu();
        },
        toggleTopbarActions() {
            this.topbarActionsOpen = !this.topbarActionsOpen;
        },
        closeTopbarActions() {
            this.topbarActionsOpen = false;
        },
        handleDocumentClick(event) {
            if (event == null || event.target == null || event.target.closest == null) {
                this.topbarActionsOpen = false;
                this.closeTopbarSubmenu();
                return;
            }
            if (this.topbarActionsOpen && event.target.closest('.app-shell-topbar__settings') == null) {
                this.topbarActionsOpen = false;
            }
            if (event.target.closest('.app-shell-topbar__submenu-flyout') == null && event.target.closest('.app-shell-topbar__item') == null) {
                this.closeTopbarSubmenu();
            }
        },
        showTopbarSubMenu(item, event) {
            if (item == null || item.subItems == null || item.subItems.length <= 1) return;
            if (this.topbarSubmenuCloseTimer) {
                clearTimeout(this.topbarSubmenuCloseTimer);
            }
            const target = event != null ? event.currentTarget : null;
            const rect = target != null ? target.getBoundingClientRect() : { left: 16, bottom: 56 };
            const maxLeft = Math.max(16, window.innerWidth - 260);
            const left = Math.min(Math.max(rect.left, 16), maxLeft);

            this.topbarSubmenuItem = item;
            this.topbarSubmenuStyle = {
                left: left + 'px',
                top: (rect.bottom + 6) + 'px'
            };
            this.topbarSubmenuHover = false;
        },
        scheduleHideTopbarSubmenu() {
            if (this.topbarSubmenuCloseTimer) {
                clearTimeout(this.topbarSubmenuCloseTimer);
            }
            this.topbarSubmenuCloseTimer = setTimeout(() => {
                if (!this.topbarSubmenuHover) {
                    this.closeTopbarSubmenu();
                }
            }, 140);
        },
        onTopbarSubmenuEnter() {
            this.topbarSubmenuHover = true;
            if (this.topbarSubmenuCloseTimer) {
                clearTimeout(this.topbarSubmenuCloseTimer);
            }
        },
        onTopbarSubmenuLeave() {
            this.topbarSubmenuHover = false;
            this.scheduleHideTopbarSubmenu();
        },
        closeTopbarSubmenu() {
            if (this.topbarSubmenuCloseTimer) {
                clearTimeout(this.topbarSubmenuCloseTimer);
                this.topbarSubmenuCloseTimer = null;
            }
            this.topbarSubmenuHover = false;
            this.topbarSubmenuItem = null;
            this.topbarSubmenuStyle = null;
        },
        onTopbarSubItemClick(id) {
            this.onClickTab(id);
            this.closeTopbarSubmenu();
        },
        toggleThemeMode() {
            this.themeMode = this.themeMode === 'light' ? 'dark' : 'light';
            localStorage.setItem('THEME_MODE', this.themeMode);
            this.applyThemeMode();
        },
        applyThemeMode() {
            document.body.classList.remove('theme-dark', 'theme-light');
            document.body.classList.add(this.themeMode === 'light' ? 'theme-light' : 'theme-dark');
        },
        applySidebarMode() {
            if (this.isSidebarCollapsed) {
                document.body.classList.add('sidebar-collapsed');
            } else {
                document.body.classList.remove('sidebar-collapsed');
            }
        },
        applyDesktopNavMode() {
            if (this.desktopNavMode === 'topbar') {
                document.body.classList.add('desktop-nav-topbar');
                document.body.classList.remove('sidebar-collapsed');
            } else {
                document.body.classList.remove('desktop-nav-topbar');
                this.applySidebarMode();
            }
        },
        isActive(item) {
            return this.$route.path === item.route;
        },
        loadUser() {
            if(localStorage.getItem('ACCESS_TOKEN') == null) return;
            AdminApiService.getProfile()
                .then((response) => {
                    localStorage.setItem('GYM', response.data.gym)
                    localStorage.setItem('PERSONAL_TRAINER', response.data.companyPayment)
                    localStorage.setItem('USER_LOCATION', response.data.customCategory)
                    this.restOfTraining = response.data.restOfTraining
                    this.expireDate = response.data.expireDate
                    this.model = response.data;
                    let expireDate = this.$moment(new Date(response.data.expireDate * 1000)).format('YYYY-MM-DD') + 'T00:00:00'
                    let today = this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00'
                    if(expireDate === today){
                        this.payment = this.locale.t("label_payment_expires_today")
                        this.paymentStyle = "color: orange;";
                    }else if(this.$moment(today).isAfter(expireDate)){
                        this.payment = this.locale.t("label_payment_already_expires")
                        this.paymentStyle = "color: red;";
                    }
                    // session.setCompanyPayment(response.data.companyPayment)
                    this.$topnavbar.$emit('getMe', response.data)
                })
                .catch(error => {
                    swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
                })
        },
        getTrainingsStyle(){
            if(this.restOfTraining === 0){
                return "background: red; color: white; border-radius: 50%; width: 25px; height: 25px; text-align: center;line-height: 12px;"
            }
            if(this.restOfTraining <= 3){
                return "background: orange; color: white; border-radius: 50%; width: 25px; height: 25px; text-align: center;line-height: 12px;"
            }
            return "background: green; color: white; border-radius: 50%; width: 25px; height: 25px; text-align: center;line-height: 12px;"
        },

        getTrainingsStyleNumber(){
            if(this.restOfTraining === 0){
                return "background: red; color: white; border-radius: 50%; width: 25px; height: 25px; text-align: center;"
            }
            if(this.restOfTraining <= 3){
                return "background: orange; color: white; border-radius: 50%; width: 25px; height: 25px; text-align: center;"
            }
            return "background: green; color: white; border-radius: 50%; width: 25px; height: 25px; text-align: center;"
        },
        moreThan50Trainings(){
            return this.restOfTraining > 50
        },
        isMobileView() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
    }
}

function loadBalance(){
    let _self = this;
    AdminApiService.getInvoicesCurrentBalance(this.companyName)
        .then((response) => {
            _self.currentBalance = response.data.currentBalance;
        })
        .catch(error => {
            // swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function reserveQrTraining(username) {
    if(this.isLoadingTrainings) return
    this.isLoadingTrainings = true
    let _self = this;
    var location = session.getGymLocationForDoor();
    let model = {
        username: username,
        location: location
    };
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});

    AdminApiService.addQrCodeTraining(model)
        .then((response) => {
            _self.isLoadingTrainings = false
            if(_self.shouldUseQrScannerAsEntrance){
                if(response.data != null && response.data.host != null && response.data.deviceId != null){
                    _self.openDoor(response.data.host, response.data.deviceId);
                }

                _self.$trainingBus.$emit('refreshEntrance')
                swal(LocService.t("label_success"), LocService.t("label_entrance_success_reserved"), 'success')

                if(_self.qrScannerFocusEnabled){
                    setTimeout(function () {
                        swal.close()
                        _self.$topnavbar.$emit('successReservedTraining')
                    }, 500);
                }
            }else{
                _self.$trainingBus.$emit('refreshTrainings')
                swal(LocService.t("label_success"), LocService.t("label_training_success_reserved"), 'success')
            }

        })
        .catch(error => {
            _self.isLoadingTrainings = false
            swal(LocService.t("label_error"), error.data.localized_error_message + '\n' + username, 'error')
        })
}

function userNotExist(data){
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});

    setTimeout(function () {
        swal(LocService.t("label_error"), LocService.t("label_user_not_exist") + '\n' + data, 'error')
    }, 500);
}

// function qrScanListener(e) {
//     let _self = this;
//
//     // Ako skener šalje Enter na kraju
//     if (e.code === 'Enter') {
//         if (_self.barcode) {
//             console.log("BARCODE enter: " + _self.barcode);
//             _self.barcode = _self.barcode.replaceAll("Shift", "")
//                 .replaceAll("shift", "")
//                 .replaceAll("?", "_")
//                 .replaceAll("CapsLock", "");
//
//             if (_self.barcode.toLowerCase().startsWith("u_")) {
//                 _self.reserveQrTraining(_self.barcode.substring(2));
//             } else {
//                 _self.userNotExist(_self.barcode);
//             }
//         }
//         _self.barcode = "";
//         return;
//     }
//
//     // Preskoči tastere koje ne želiš
//     if (e.key.length === 1) { // prihvati samo printable karaktere
//         _self.barcode += e.key;
//     }
//
//     // Restartuj timeout svaki put kad dođe novi key
//     if (_self.barcodeTimeout) {
//         clearTimeout(_self.barcodeTimeout);
//     }
//
//     // Timeout od 100ms – znači kraj unosa
//     _self.barcodeTimeout = setTimeout(() => {
//         if (_self.barcode) {
//             console.log("BARCODE timeout: " + _self.barcode);
//             _self.barcode = _self.barcode.replaceAll("Shift", "")
//                 .replaceAll("shift", "")
//                 .replaceAll("?", "_")
//                 .replaceAll("CapsLock", "");
//
//             if (_self.barcode.toLowerCase().startsWith("u_")) {
//                 _self.reserveQrTraining(_self.barcode.substring(2));
//             } else {
//                 _self.userNotExist(_self.barcode);
//             }
//             _self.barcode = "";
//         }
//     }, 100);
// }

// old code - sacvati dok ne budem siguran da ovaj radi
// function qrScanListenerOld(e){
//     let _self = this;
//     if(_self.interval){
//         clearInterval(_self.interval)
//     }
//     if(e.code === 'Enter'){
//         if(_self.barcode){
//             console.log("BARCODE: " + _self.barcode);
//             // handleBarCode(_self.barcode)
//             _self.barcode = _self.barcode.replaceAll("Shift", "").replaceAll("shift","").replaceAll("?","_")
//             _self.barcode = _self.barcode.replaceAll("CapsLock", "")
//             // console.log("BARCODE: "+ _self.barcode);
//             if(_self.barcode.toLowerCase().startsWith("u_")){
//                 // console.log("DATA " + _self.barcode)
//                 _self.reserveQrTraining(_self.barcode.substring(2, _self.barcode.length));
//             }else{
//                 // _self.reserveQrTraining("samoadmin");
//                 _self.userNotExist(_self.barcode);
//             }
//         }
//         _self.barcode = "";
//         return;
//     }
//     if(e.code !== 'Shift'){
//         _self.barcode += e.key;
//     }
//     _self.interval = setInterval(()=> _self.barcode = '', 20)
// }

function qrScanListener(e) {
    let _self = this;

    // Inicijalizacija barcode promenljive ako ne postoji
    if (!_self.barcode) _self.barcode = "";

    // Očisti prethodni timeout ako postoji
    if (_self.timeout) {
        clearTimeout(_self.timeout);
    }

    // Ako je pritisnut Enter, procesuiraj barcode
    if (e.code === 'Enter') {
        if (_self.barcode) {
            console.log("BARCODE: " + _self.barcode);

            _self.barcode = _self.barcode
                .replaceAll("Shift", "")
                .replaceAll("shift", "")
                .replaceAll("?", "_")
                .replaceAll("CapsLock", "");

            if (_self.barcode.toLowerCase().startsWith("u_")) {
                _self.reserveQrTraining(_self.barcode.substring(2));
            } else {
                _self.userNotExist(_self.barcode);
            }
        }

        _self.barcode = "";
        return;
    }

    // Dodaj karakter ako nije Shift
    if (e.key != null && e.key.length === 1) {
        _self.barcode += e.key;
    }

    // Postavi timeout da obriše barcode posle 100ms neaktivnosti
    _self.timeout = setTimeout(() => {
        _self.barcode = "";
    }, 100);
}


function generateTabs(){
    let self = this;
    self.tabs = []
    let addedIds = [];
    var specificTabs = null;
    if(CONFIG_COMPANY.SPECIFIC_ROLES != null){
        if(CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()] != null){
            if(CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()].TABS != null){
                specificTabs = CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()].TABS;
            }
        }
    }
    let tabs = specificTabs != null ? specificTabs.split(",") : CONFIG_COMPANY.TABS.split(",")
    console.log("maytabs: " + tabs)
    console.log("myCompay: " + CONFIG_COMPANY.NAME)
    tabs.forEach(e => {
        if(TAB_CONFIG[e] != null){
            var item = TAB_CONFIG[e]
            if(item.role.includes(this.myRole)){
                item.isOpen = false
                item.subItems = []
                if(item.subMenu != null){
                    item.subMenu.forEach(subItem => {
                        if(subItem.role.includes( this.myRole)){
                            if(tabs.includes(subItem.id)){
                                if(self.isMobileView()){
                                    if(!addedIds.includes(subItem.id)){
                                        self.tabs.push(subItem)
                                        addedIds.push(subItem.id)
                                    }
                                }else{
                                    item.subItems.push(subItem)
                                }

                            }
                        }
                    })
                }

                if(self.isMobileView()){
                    if(!addedIds.includes(item.id)){
                        self.tabs.push(item)
                        addedIds.push(item.id)
                    }
                }else{
                    self.tabs.push(item)
                }

            }

        }
    });
    if (self.isChatEnabled() && TAB_CONFIG.ADMIN_CHAT != null && TAB_CONFIG.ADMIN_CHAT.role.includes(this.myRole) && !addedIds.includes(TAB_CONFIG.ADMIN_CHAT.id)) {
        self.tabs.push(TAB_CONFIG.ADMIN_CHAT)
    }
}

function onClickTabFromParent(item){
    if(item.subItems != null && item.subItems.length > 0){
        this.onClickTab(item.subItems[0].id)
    }
}

function onClickTab(id, item){
    switch (id) {
        case "HOME": {
            this.home();
            break;
        }
        case "TRAININGS": {
            this.trainings();
            break;
        }
        case "REPORT_TR": {
            this.trainingReport();
            break;
        }
        case "USERS": {
            this.users();
            break;
        }
        case "EMPLOYED_USR": {
            this.employedUsers();
            break;
        }
        case "EMPLOYED_TRM": {
            this.terms();
            break;
        }
        case "SCHEDULE": {
            this.terms();
            break;
        }
        case "NOTIFICATION": {
            this.notifications();
            break;
        }
        case "CAMPAIGN": {
            this.campaign();
            break;
        }
        case "RPRT_TRAINER": {
            this.trainerReport();
            break;
        }
        case "PAYMENTS": {
            this.paymentReport();
            break;
        }
        case "PARTNERS": {
            this.saradnici();
            break;
        }
        case "COMPANY_PARTNERS": {
            this.companyPartner();
            break;
        }
        case "BAR_SALDO_REPORT": {
            this.barSaldoDebtors();
            break;
        }
        case "SHOP": {
            this.shop();
            break;
        }
        case "MEMBERSHIPS": {
            this.membershipPackages();
            break;
        }
        case "INVOICES": {
            this.invoices();
            break;
        }
        case "INVENTORY": {
            this.inventory();
            break;
        }
        case "ARTICLES": {
            this.articles();
            break;
        }
        case "PROFIT": {
            this.profit();
            break;
        }
        case "COMPANIES": {
            this.companies();
            break;
        }
        case "WOD": {
            this.wod();
            break;
        }
        case "BAR_POS": {
            this.barPos();
            break;
        }
        case "PERSONAL": {
            this.personal();
            break;
        }
        case "USR_REPORT": {
            this.userReport();
            break;
        }
        case "CASHBACK_CREDIT": {
            this.userCredits();
            break;
        }
        case "DOCUMENTATIONS": {
            this.docs();
            break;
        }
        case "ADMIN_CHAT": {
            this.adminChat();
            break;
        }
        case "TIMED_SLOTS": {
            this.timedSlots();
            break;
        }

        case "CAMPAIGN_COMPANY": {
            this.campaignCompany();
            break;
        }

        case "TRN_TYPES": {
            this.trainingTypes();
            break;
        }

        case "WAREHOUSE": {
            this.warehouses();
            break;
        }

        case "ARTICLE_REPORT": {
            this.articleReport();
            break;
        }

        case "ENTRANCE": {
            this.entrance();
            // ovo je za test umesto skenera
            // this.reserveQrTraining('testnik');
            // this.runPythonScript();
            break;
        }

        case "ENTRA_TRAINER": {
            this.entrance();
            // ovo je za test umesto skenera
            // this.reserveQrTraining('testnik');
            // this.runPythonScript();
            break;
        }

        case "CSCHEDULE": {
            this.cSchedule();
            break;
        }

        case "SUBSCRIPTIONS": {
            this.subscriptions();
            break;
        }
        case "ORDERS": {
            this.orders();
            break;
        }
        case "ORDR_RESERVATION": {
            this.ordersReservation();
            break;
        }

        if(item != null && item.subItems != null){
            item.isOpen = false
        }
    }
}

function openDoor(host, deviceId) {
    fetch('http://localhost:3000/open-door?baseURL=' + host +'&deviceId=' + deviceId)
        .then(response => response.text())
        .then(data => {
            console.log(data);
        })
        .catch(error => console.error('Greška:', error));
}

function setTimer(pulse) {
    fetch('http://localhost:3000/set-timer?baseURL=http://172.20.10.2:8081&deviceId=1000b8b8b3&pulse='+pulse)
        .then(response => response.text())
        .then(data => {
            console.log(data);
        })
        .catch(error => console.error('Greška:', error));
}

function listenQrApproved(){
    if(!CONFIG_COMPANY.LISTEN_FIREBASE_QR_SCAN) return
    session.getConfig()
    let _self = this;
    window.db.ref("resource/"+CONFIG_COMPANY.NAME).on('value', (snapshot) => {
        const data = snapshot.val();
        if(data == null) return;
        if(session.getGymLocation() != null && session.getGymLocation().length > 0){
            if(!session.getGymLocation().includes(data.gymLocation)){
                return;
            }
        }
        if(data != null && !session.isSameLastScannedQrUser(data)){
            session.setLastScannedQrUser(data)
            if(data.error != null && data.error.length > 0){
                swal(LocService.t('label_error'), data.error + " ("+ data.name + " " + data.lastName +") ", 'error')
            }else{
                var isExpire = data.expiredPayment != null && data.expiredPayment === true;
                var expireText =  isExpire ? "<br><b>"+ LocService.t('label_expire_payment_for_user')+"</b>" : "";
                if(data.trainingType === "_QR_CODE_TRAINING"){
                    swal(LocService.t('label_success_qr_code_scan_title'), LocService.t('label_success_qr_code_scan') + " <br> " + LocService.t('label_user') + ": "+ data.name + " " + data.lastName +" " + expireText, isExpire ? 'warning' : 'success')
                    _self.$trainingBus.$emit('refreshTrainings')
                }else if(data.trainingType === "SUCCESS_APPROVE_TRAINING"){
                    swal(LocService.t('label_success_qr_code_approve_title'), LocService.t('label_success_qr_code_approve') +" <br>" + LocService.t('label_user') + ": "+ data.name + " " + data.lastName +" " + expireText, isExpire ? 'warning' : 'success')
                    _self.$trainingBus.$emit('refreshTrainings')
                }
            }
        }
    });
}

function listenRemoteOpenDoor(){
    if(CONFIG_COMPANY.ENABLE_REMOTE_OPEN_DOOR !== true) return
    let _self = this;
    window.db.ref("resource/door/"+CONFIG_COMPANY.NAME).on('value', (snapshot) => {
        const data = snapshot.val();
        console.log()
        if(data == null || data.host == null || data.deviceId == null) return;
        _self.openDoorSonOff(data.host, data.deviceId);
        _self.resetRemoteAfterOpen()
    });
}

function openDoorSonOff(host, deviceId) {
    fetch('http://localhost:3000/open-door?baseURL=' + host +'&deviceId=' + deviceId)
        .then(response => response.text())
        .then(data => {
            console.log(data);
        })
        .catch(error =>{
            console.error('Greška:', error)
        });
}

function resetRemoteAfterOpen(){
    let _self = this;
    AdminApiService.resetDoorEntranceRemote()
        .then((response) => {

        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Layout/TopNavbar.js